import MapPageContainer from "./MapPageContainer";

export default MapPageContainer;
